module.exports = __webpack_public_path__ + "static/media/ipad.037ac7d3.png";